export default __webpack_public_path__ + "static/media/step3.3ea58556.png";